import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { toast } from 'react-toastify';
import Button from '../../../../_common/Form/Buttons/Button';
import classes from './tabs.module.scss';
import accountHelpers from '../../../../../utils/accountHelpers';
import { addPatientNodeRequest, getPatientsNodeRequest } from '../../../../../store/actions/patients';
import Loader from '../../../../_common/Loader/Loader';
import NoteModal from '../../../../_common/Modal/NoteModal/NoteModal';

let firstLoad = true;

function InfoNodes() {
  const dispatch = useDispatch();
  const { patientNodeList, requestStatus } = useSelector((store) => store.patients);
  const { patientId } = useParams();

  const [requestData, setRequestData] = useState({
    patientId,
    note: '',
    private: false,
    userId: accountHelpers.getUser().id,
  });
  const [isOpenModal, setIsOpenModal] = useState(false);

  const changeNoteData = (path, value) => {
    setRequestData((prev) => ({ ...prev, [path === 'privateBody' ? 'private' : path]: value }));
  };

  const onSndNoteClick = async () => {
    if (!requestData.note) {
      toast.error('Please write note');
      return;
    }

    const { status } = await dispatch(addPatientNodeRequest(requestData));

    if (status === 'ok') {
      await dispatch(getPatientsNodeRequest({ patientId, userId: accountHelpers.getUser().id }));

      setRequestData((prev) => ({ ...prev, private: false, note: '' }));

      setIsOpenModal(false);
    }
  };

  useEffect(() => {
    (async () => {
      await dispatch(getPatientsNodeRequest({ patientId, userId: accountHelpers.getUser().id }));
    })();

    firstLoad = false;
  }, []);

  return (
    <div className={classes.info_wrapper}>
      <h2>Additional Addresses:</h2>

      <div>
        <Button
          className={classes.add_btn}
          title="Add note"
          type="button"
          onClick={() => setIsOpenModal(true)}
          reverseColor
          addButton
        />

        <div className={classes.note_wrapper}>
          <div className={classes.note_header}>
            Note
          </div>

          {requestStatus === 'request' && firstLoad && (
          <div className={classes.note_loader}>
            <Loader />
          </div>
          )}

          {requestStatus === 'success' && (
          <>
            {!patientNodeList.length
              ? <div className={classes.notResult}>No Data Found</div>

              : (
                <div className={classes.note_main}>
                  {patientNodeList.map((p) => (
                    <div key={p.id}>
                      <div>
                        <p>{p.User.name}</p>

                        <p>
                          {moment.utc(p.createdAt).local().calendar({
                            sameDay: 'LT',
                            nextDay: 'MM.DD LT',
                            nextWeek: 'MM.DD LT',
                            lastDay: 'MM.DD LT',
                            lastWeek: 'MM.DD LT',
                            sameElse: 'MM.DD.YYYY LT',
                          })}
                        </p>
                      </div>

                      <p>{p.note}</p>
                    </div>
                  ))}
                </div>
              )}
          </>
          )}

        </div>
      </div>

      <NoteModal
        isOpenModal={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        noteData={{ note: requestData.note, privateBody: requestData.private }}
        onChangeNoteData={changeNoteData}
        saveNote={onSndNoteClick}
      />

    </div>
  );
}

export default InfoNodes;
